export const TEST_ID = 'searchDrawer';

// FAA drawer v2 spec, "Search Drawer (default state)" — locked eyebrow + CTA
// copy. All user-facing strings live here rather than inline JSX.
export const EYEBROW_LABEL = 'FIND A LOCATION';

export const CURRENT_LOCATION_LABEL = 'Current location';

export const SAVED_PLACES_LABEL = 'Saved places';

export const RECENT_SECTION_TITLE = 'Recent';

export const RESULTS_SECTION_TITLE = 'Results';

// Empty state copy gets the query interpolated at render.
export const EMPTY_STATE_PREFIX = 'No results for "';

export const EMPTY_STATE_SUFFIX = '"';

// Mobile drag thresholds — match useSheetDrag's 40px commit distance for
// consistent feel across the airspace drawer subsystem.
export const EXPAND_DRAG_PX = 40;

export const COLLAPSE_DRAG_PX = 40;

// "Current location" icon — 18×18 viewBox, 1.5px stroke crosshair + center dot.
export const LOCATION_ICON_SIZE = 18;

export const LOCATION_ICON_STROKE_WIDTH = 1.5;

export const LOCATION_CENTER = 9;

export const LOCATION_DOT_R = 2.5;

export const LOCATION_OUTER_R = 6;

export const LOCATION_TICK_OUTER_START = 0.5;

export const LOCATION_TICK_OUTER_END = 17.5;

export const LOCATION_TICK_INNER_START = 3;

export const LOCATION_TICK_INNER_END = 15;

// "Saved places" icon — calendar / bookmark 16×16 outline.
export const SAVED_ICON_SIZE = 16;

export const SAVED_ICON_STROKE_WIDTH = 1.5;

export const SAVED_RECT_X = 2;

export const SAVED_RECT_Y = 3;

export const SAVED_RECT_WIDTH = 12;

export const SAVED_RECT_HEIGHT = 10;

export const SAVED_RECT_RX = 1.5;

export const SAVED_LEG_LEFT_X = 5;

export const SAVED_LEG_RIGHT_X = 11;

export const SAVED_LEG_Y_START = 1.5;

export const SAVED_LEG_Y_END = 4.5;

export const SAVED_DIVIDER_Y = 6.5;

export const SAVED_DIVIDER_X_START = 2;

export const SAVED_DIVIDER_X_END = 14;
